import React from 'react';
import { ATMTab, IATMTabProps } from 'shared-it-appmod-ui';
import history from 'src/history';
import useTabLocation from 'src/hooks/tab-location.hook';
import styles from './tabs.module.scss';

const Tabs: React.FC<IATMTabProps> = (props) => {
  const { currentTab, pathname, params } = useTabLocation();

  return (
    <div className={styles.container}>
      <ATMTab
        {...props}
        activeIndex={currentTab}
        className="tab-menu"
        onTabChange={(_, data) => {
          params.delete('tab');
          params.delete('page');
          const url =
            params.toString() === ''
              ? `${pathname}?tab=${data.activeIndex}`
              : `${pathname}?tab=${data.activeIndex}&${params.toString()}`;
          history.push(url);
        }}
      />
    </div>
  );
};

export default Tabs;
